<template>
    <section class="section feature-split" data-aos="fade-up">
        <div class="container split-layout">
            <div class="split-image">
                <img :src="image" :alt="altText" />
                <div class="image-caption">
                    <h3>{{ captionTitle }}</h3>
                    <p>{{ captionDesc }}</p>
                    <router-link :to="captionLink" class="btn-link">Learn More <i
                            class="fas fa-chevron-right"></i></router-link>
                </div>
            </div>
            <div class="split-content">
                <h2>{{ title }}</h2>
                <ul class="feature-list">
                    <li>
                        <router-link :to="buttonLink" class="btn-primary">{{ buttonText }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FeatureSplit',
    props: {
        image: String,
        altText: String,
        captionTitle: String,
        captionDesc: String,
        captionLink: String,
        title: String,
        buttonLink: String,
        buttonText: String,
    },
};
</script>

<style scoped>
.section.feature-split {
    padding: 80px 0;
    background-color: #fff;
}

.split-layout {
    display: flex;
    align-items: center;
    gap: 60px;
    flex-wrap: wrap;
}

.split-image {
    flex: 1;
    position: relative;
    text-align: center;
}

.split-image img {
    max-width: 100%;
    border-radius: 30px;
}

.image-caption {
    margin-top: 20px;
}

.image-caption h3 {
    font-size: 1.8rem;
    margin-bottom: 8px;
}

.image-caption p {
    color: #6c757d;
    margin-bottom: 16px;
}

.btn-link {
    color: #0071e3;
    text-decoration: none;
    font-weight: 500;
}

.btn-link i {
    transition: transform 0.2s;
}

.btn-link:hover i {
    transform: translateX(4px);
}

.split-content {
    flex: 1;
}

.split-content h2 {
    font-size: 2.5rem;
    margin-bottom: 24px;
}

.feature-list {
    list-style: none;
    padding: 0;
}

.btn-primary {
    display: inline-block;
    background-color: #0071e3;
    color: white;
    padding: 12px 28px;
    border-radius: 40px;
    text-decoration: none;
    font-weight: 500;
}

.btn-primary:hover {
    background-color: #005bb5;
}

@media (max-width: 768px) {
    .split-layout {
        flex-direction: column;
    }

    .split-content h2 {
        font-size: 1.8rem;
    }
}
</style>